import { render, staticRenderFns } from "./PartialForm.vue?vue&type=template&id=4fa3943e&scoped=true"
import script from "./PartialForm.vue?vue&type=script&lang=js"
export * from "./PartialForm.vue?vue&type=script&lang=js"
import style0 from "./PartialForm.vue?vue&type=style&index=0&id=4fa3943e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa3943e",
  null
  
)

export default component.exports